exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "  .background {\n    height: 10em;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    background-size: cover;\n    background-position: center;\n}\n\n.background > h4 {\n    color: #000;\n    font-size: 2em;\n    font-family: sans-serif;\n}\n\n.lb-outerContainer {\n    /*top: 200px !important;*/\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/src/app/student/student.component.css
// module id = ../../../../../src/app/student/student.component.css
// module chunks = 0